<template>
<div class="flex">
  <div class="flex-none">
  <Toggler
    :modelValue="modelValue"
    :id="ToggleId"
    role="switch"
    :disabled="disabled"
    :aria-checked="modelValue"
    :onLabel="ontext"
    :offLabel="offtext"
    @change="$emit('update:modelValue', $event)"
    labelledby="toggle-label"
    :classes="{
      container: 'inline-block rounded-full outline-none focus:none',
      toggle: 'flex w-16 h-6 rounded-full relative cursor-pointer transition items-center box-content border-2 font-medium text-xs leading-none',
      toggleOn: 'bg-skin-active128 border-transparent justify-start text-skin-b-invt',
      toggleOff: 'bg-skin-b-back border-skin-b-list-bord justify-end text-skin-b-base',
      toggleOnDisabled: 'bg-slate-300 border-slate-300 justify-start text-slate-400 cursor-not-allowed',
      toggleOffDisabled: 'bg-slate-200 border-slate-200 justify-end text-slate-400 cursor-not-allowed',
      handle: 'inline-block bg-white w-6 h-6 top-0 rounded-full absolute transition-all',
      handleOn: 'left-full transform -translate-x-full',
      handleOff: 'left-0',
      handleOnDisabled: 'bg-slate-100 left-full transform -translate-x-full',
      handleOffDisabled: 'bg-slate-100 left-0',
      label: 'text-center w-12 border-box whitespace-nowrap select-none',
    }"
  />
  </div>
  <div class="flex-1 ml-3">
    <SrcInputLabel v-if="label" :for="ToggleId" class="relative"
    :class="{'text-red-600':labelcolor=='red'}"
    >
      {{ label }} 
      <span class="relative">
        <IconInfo 
          v-if="tooltipText" 
          class="inline-flex w-5 h-5 ml-1 -mt-0.5 cursor-pointer" 
          @click="toggleTooltip"
          @mouseleave="hideTooltip"
          aria-label="More info"
        />
        <transition
        enter-active-class="transition-opacity duration-300"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-300"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
        >
          <div
            v-if="showTooltip"
            :class="tooltipClasses"
            class="absolute transform w-64 bg-gray-800 text-white text-sm p-2 rounded-lg shadow-lg z-50"
          >
            {{ tooltipText }}
          </div>
        </transition>
      </span>

    </SrcInputLabel>
  </div>
</div>
</template>

<script>
import Toggler from '@vueform/toggle'
import SrcInputLabel from '../sources/SrcInputLabel.vue'
import IconInfo from '../icons/IconInfo.vue'

export default {
  components: {
    Toggler,
    SrcInputLabel, 
    IconInfo,
  },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    labelcolor: {
      type: String,
      default: '',
    },
    tooltipText: {
      type: String,
      default: '',
    },
    tooltipPosition: {
      type: String,
      default: 'top-center',
      validator: (value) => ['top-left', 'top-center', 'top-right'].includes(value),
    },
    ontext: {
      type: String,
      default: 'On',
    },
    offtext: {
      type: String,
      default: 'Off',
    },
  },
  data() {
    return {
      ToggleId: `Toggle-${Math.random().toString(36).substring(7)}`,
      showTooltip: false, // Controls tooltip visibility
    }
  },
  computed: {
    tooltipClasses() {
      switch (this.tooltipPosition) {
        case 'top-left':
          return 'left-0 -top-2 -translate-y-full';
        case 'top-center':
          return 'left-1/2 -top-2 -translate-x-1/2 -translate-y-full';
        case 'top-right':
          return 'right-0 -top-2 -translate-y-full';
        default:
          return 'left-1/2 -top-2 -translate-x-1/2 -translate-y-full';
      }
    },
  },
  methods: {
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    hideTooltip() {
      this.showTooltip = false;
    }
  },
}
</script>

<style scoped>
@media (max-width: 640px) {
  div[tooltip] {
    width: auto;
    max-width: 90vw;
  }
}
</style>